
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.417 7.559c0-2.901-2.872-5.25-6.416-5.25-3.545 0-6.417 2.349-6.417 5.25 0 1.125.435 2.162 1.172 3.018a7.42 7.42 0 01-1.104 1.789.274.274 0 00-.046.285c.04.098.126.158.225.158 1.129 0 2.064-.404 2.736-.82.993.514 2.169.82 3.434.82 3.544 0 6.416-2.35 6.416-5.25z","fill":"#348EF6"}})])
          )
        }
      }
    